import React, {useEffect, useState} from "react";
import Typography from '@material-ui/core/Typography';
import Slider from '@material-ui/core/Slider';
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({

    margin: {
        height: theme.spacing(3)
    },
    thumbBlack: {
        background: "#BB0D66",
    },
    thumbRed: {
        marginTop: "-7px",
        background: "#E70404FF",
    },
    rail: {
        background: "rgba(231, 4, 4, 0.5)",
        position: "relative",
        top: 2,
        "&:after": {
            position: "absolute",
            content: '""',
            top: 0,
            left: 0,
            right: 0,
            height: "2px",
            background: "#000",
        }
    },
    valueLabelBeforeMaxAllowed: {
        "&>*": {
            background: "#BB0D66"
        }
    },
    valueLabelAfterMaxAllowed: {
        "&>*": {
            background: "#E70404FF"
        }
    },
    trackBeforeMaxAllowed: {
        background: "#000",
    },
    trackAfterMaxAllowed: {
        background: "#E70404FF",
        position: "relative",
        "&:after": {
            position: "absolute",
            content: '""',
            width: properties => properties.width,
            top: 0,
            left: 0,
            right: 0,
            height: "2px",
            background: "#000",
        }
    },
    markBeforeMaxAllowed: {
        background: "#000",
    },
    markAfterMaxAllowed: {
        background: "#E70404FF",
        position: "relative",
        "&:after": {
            position: "absolute",
            content: '""',
            width: "2px",
            borderRadius: "2px",
            top: -2,
            left: 0,
            right: 0,
            height: "2px",
            background: "#000",
        }
    },
}));

const FormikSlider = ({label, disabled, ...props}) => {
    const classes = useStyles();
    const {form: {setFieldValue}, field, interval, min, max, alternative} = props;
    const [value, setValue] = useState(field.value);

    let marks = [];

    for(let i=0; i<=max; i+=interval){
        let item = {value: i, label: `${i}%`};
        marks.push(item)
    }

    useEffect(() => {
        setValue(field.value);
    }, [field.value])

    const onChange = (e, v) => {
        setValue(v);
        setFieldValue(field.name, v);
    };

    return (
        <div>
            <Typography gutterBottom>
                {label }
            </Typography>

            <Slider
                classes={{
                    thumb: alternative ? !disabled && classes.thumbRed : classes.thumbBlack,
                    rail: classes.rail,
                    track: alternative ? classes.trackAfterMaxAllowed : classes.trackBeforeMaxAllowed,
                    valueLabel: alternative ? classes.valueLabelAfterMaxAllowed : classes.valueLabelBeforeMaxAllowed,
                    mark: alternative ? classes.markAfterMaxAllowed : classes.markBeforeMaxAllowed,
                }}
                valueLabelDisplay="auto"
                marks={marks}
                value={value}
                step={1}
                min={min}
                max={max}
                onChange={onChange}
                disabled={disabled}
            />
        </div>
    );
};

export default FormikSlider;
